// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const accountStep = "AccountStep__accountStep__h6K6J";
export const buttonWrapper = "AccountStep__buttonWrapper__cjF2E";
export const accountTypeWrapper = "AccountStep__accountTypeWrapper__qlG-7";
export const fieldWrapper = "AccountStep__fieldWrapper__W1kCb";
export const hidden = "AccountStep__hidden__CmYio";
export const tooltip = "AccountStep__tooltip__pLdeh";